var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconErrorMid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_error_mid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_error_mid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    stroke: "#C60000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93768812,1.77118867 C9.41981727,0.792988177 8.57798271,0.797143772 8.06231188,1.77118867 L0.937688118,15.2288113 C0.41981727,16.2070118 0.892622799,17 1.99508929,17 L16.0049107,17 C17.1067681,17 17.5779827,16.2028562 17.0623119,15.2288113 L9.93768812,1.77118867 Z",
    id: "Page-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(8.000000, 6.000000)",
    fill: "#C60000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,6 L1,6 C0.448,6 0,5.616 0,5.14285714 L0,0.857142857 C0,0.384 0.448,0 1,0 L1,0 C1.552,0 2,0.384 2,0.857142857 L2,5.14285714 C2,5.616 1.552,6 1,6",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,9 L1,9 C0.448,9 0,8.552 0,8 L0,8 C0,7.448 0.448,7 1,7 L1,7 C1.552,7 2,7.448 2,8 L2,8 C2,8.552 1.552,9 1,9",
    id: "Fill-3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorMid);
export default __webpack_public_path__ + "static/media/icon_error_mid.7deb2ef02702c54fd7c726422eda1a2f.svg";
export { ForwardRef as ReactComponent };